import React, { useRef } from 'react';
import { ErrorLoggerContext, noopErrorLogger } from './context.mjs';

function NoopBoundary({
  children
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}
function Bugsnag({
  client,
  children
}) {
  const Boundary = useRef(() => {
    if (client) {
      const reactPlugin = client.getPlugin('react');

      if (reactPlugin == null) {
        // eslint-disable-next-line no-console
        console.warn('You are using bugsnag without the React plugin. For better insight into your errors you should add @bugsnag/plugin-react to your configuration.');
        return NoopBoundary;
      }

      return reactPlugin.createErrorBoundary(React);
    }

    return NoopBoundary;
  }).current();
  return /*#__PURE__*/React.createElement(ErrorLoggerContext.Provider, {
    value: client || noopErrorLogger
  }, /*#__PURE__*/React.createElement(Boundary, null, children));
}

export { Bugsnag, NoopBoundary };
